const unitOfMeasureMap: Record<string, string> = {
  pack: 'PK',
  gross: 'GRO',
  pound: 'LBR',
  bag: 'BG',
  box: 'BX',
  '1/4 lb': 'LBR',
  '1/2 lb': 'LBR',
  weekly: 'WEE',
  case: 'CS',
  'stone uom': 'STI',
  bundle: 'BU',
  day: 'DAY',
  drum: 'DR',
  dwt: 'DWT',
  dozen: 'DZN',
  each: 'EA',
  gram: 'GRM',
  hour: 'HUR',
  'cubic inches': 'INQ',
  kilograms: 'KGM',
  minute: 'MIN',
  millimeter: 'MMT',
  meter: 'MTR',
  monthly: 'MON',
  ounce: 'ONZ',
  'avoir ounces': 'ONZ',
  pad: 'PD',
  pail: 'PL',
  pair: 'PR',
  quarterly: 'QAN',
  set: 'SET',
  strip: 'SR',
  thousand: 'MIL',
  tube: 'TU',
  dollar: 'USD',
  volume: 'LTR',
  inch: 'INH',
  feet: 'FT',
  gallon: 'GLL',
  yearly: 'ANN'
}

/**
 * When given a sold by description, return the UNECE code for that unit of measure
 */
export function getUnitCode (soldByDescription: string): string | undefined {
  const soldBy = soldByDescription.toLowerCase()
  if (unitOfMeasureMap[soldBy] != null) {
    return unitOfMeasureMap[soldBy]
  }
  for (const [uom, code] of Object.entries(unitOfMeasureMap)) {
    // handle instances of descriptions like 'case of', 'box of', 'pack of', which do not have distinct codes (these examples would use 'CS', 'BX', and 'PK')
    if (soldBy.includes(uom)) {
      return code
    }
  }
}
